/*
  Blog: "Perguntas frequentes" do texto em acordeão e botão de copiar o link.
  O acordeão só é montado quando a seção segue o formato dos artigos: um H2 com
  "Perguntas frequentes" seguido de pares H3 (pergunta) + resposta até o próximo H2.
*/
(() => {
  const buildFaq = (rte) => {
    const heading = Array.from(rte.querySelectorAll('h2')).find((h2) => /perguntas frequentes|d[úu]vidas frequentes/i.test(h2.textContent));
    if (!heading) return;

    const items = [];
    let current = null;
    let node = heading.nextElementSibling;

    while (node && node.tagName !== 'H2') {
      const next = node.nextElementSibling;
      if (node.tagName === 'H3') {
        current = { question: node, answer: [] };
        items.push(current);
      } else if (current) {
        current.answer.push(node);
      } else {
        return; // conteúdo antes da primeira pergunta: deixa como está
      }
      node = next;
    }

    if (items.length < 2) return;

    const list = document.createElement('div');
    list.className = 'post-faq';

    items.forEach(({ question, answer }) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const body = document.createElement('div');

      summary.textContent = question.textContent.trim();
      body.className = 'post-faq__answer';
      answer.forEach((part) => body.appendChild(part));
      details.append(summary, body);
      list.appendChild(details);
      question.remove();
    });

    heading.after(list);
  };

  const setupCopy = (button) => {
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(button.dataset.url);
        const label = button.textContent;
        button.textContent = button.dataset.done;
        setTimeout(() => { button.textContent = label; }, 2000);
      } catch (error) {
        window.prompt('Copie o link:', button.dataset.url);
      }
    });
  };

  const init = () => {
    document.querySelectorAll('.js-post-rte').forEach(buildFaq);
    document.querySelectorAll('.js-post-copy').forEach(setupCopy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
